// import { InputHTMLAttributes } from 'react';

// interface CheckboxProps
//   extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
//   inputClassName?: string;
//   label: string;
// }

function Checkbox({
  name,
  label,
  checked,
  className,
  inputClassName,
  ...rest
}) {
  if (!name || !label) {
    throw new Error("Checkbox requires name and label props");
  }

  return (
    <div className={className}>
      <label className="m-0" htmlFor={name}>
        <input
          id={name}
          className={inputClassName}
          type="checkbox"
          name={name}
          checked={checked}
          {...rest}
        />
        &nbsp;{label}
      </label>
    </div>
  );
}

export default Checkbox;
